export const SENTRY_DSN = import.meta.env.VITE_EVENT_TEAM_SENTRY_DSN
export const SENTRY_TRACES_SAMPLE_RATE = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE
export const SENTRY_PROFILES_SAMPLE_RATE = import.meta.env.VITE_SENTRY_PROFILES_SAMPLE_RATE
